import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOnePR_LessonsLearnedById = createAsyncThunk(
  "api/PR_LessonsLearned/GetOnePR_LessonsLearnedById",
  async (pR_LessonsLearnedId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_LessonsLearned/GetOnePR_LessonsLearnedById",
        {
          pR_LessonsLearnedId: pR_LessonsLearnedId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddPR_LessonsLearned = createAsyncThunk(
  "PR_LessonsLearned/AddPR_LessonsLearned",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_LessonsLearned/AddPR_LessonsLearned",
        {
          lessonsLearnedDescription: model.lessonsLearnedDescription,
          pR_ReportsStagesGuid: model.pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdatePR_LessonsLearned = createAsyncThunk(
  "PR_LessonsLearned/UpdatePR_LessonsLearned",
  async (update, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_LessonsLearned/UpdatePR_LessonsLearned",
        {
          pR_LessonsLearnedId: update.pR_LessonsLearnedId,
          lessonsLearnedDescription: update.lessonsLearnedDescription,
          pR_ReportsStagesGuid: update.pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeletePR_LessonsLearnedById = createAsyncThunk(
  "PR_LessonsLearned/DeletePR_LessonsLearnedById",
  async (pR_LessonsLearnedId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_LessonsLearned/DeletePR_LessonsLearnedById",
        {
          pR_LessonsLearnedId: pR_LessonsLearnedId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowNoteLessonsLearned = createAsyncThunk(
  "GetSpecificRowNoteLessonsLearned/GetSpecificRowNoteLessonsLearned",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      // return data.filter((item) => item.incrementNumber - 1 === 1);
        return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const LessonsLearned = createSlice({
  name: "LessonsLearned",
  initialState: {
    //-------------------------- ONE -----------------------------------------------
    LessonsLearned: [],
    loadingLessonsLearned: false,
    errorLessonsLearned: null,
    //-------------------------- Add -----------------------------------------------
    AddLessonsLearned: [],
    loadingAddLessonsLearned: false,
    errorAddLessonsLearned: null,
    //-------------------------- update -----------------------------------------------
    UpdateLisLessonsLearned: [],
    loadingUpdateLisLessonsLearned: false,
    errorUpdateLisLessonsLearned: null,
    //-------------------------- delete -----------------------------------------------
    DeleteLessonsLearned: [],
    loadingDeleteLessonsLearned: false,
    errorDeleteLessonsLearned: null,
    //-------------------------- Get Specific Row Note LessonsLearned ------------------------------------------.
    OneSpecificRowNoteLessonsLearned: {},
    loadingOneSpecificRowNoteLessonsLearned: false,
    errorOneSpecificRowNoteLessonsLearned: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetOnePR_LessonsLearnedById.pending, (state, action) => {
        state.loadingLessonsLearned = true;
        state.LessonsLearned = action.payload;
        state.errorLessonsLearned = null;
      })
      .addCase(GetOnePR_LessonsLearnedById.fulfilled, (state, action) => {
        state.loadingLessonsLearned = false;
        state.LessonsLearned = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOnePR_LessonsLearnedById.rejected, (state, action) => {
        state.loadingLessonsLearned = false;
        state.errorLessonsLearned = action.payload;
      })
      //---------------------------- Add ------------------------------------------
      .addCase(AddPR_LessonsLearned.pending, (state, action) => {
        state.loadingAddLessonsLearned = true;
        state.AddLessonsLearned = action.payload;
        state.errorAddLessonsLearned = null;
      })
      .addCase(AddPR_LessonsLearned.fulfilled, (state, action) => {
        state.loadingAddLessonsLearned = false;
        state.AddLessonsLearned = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddPR_LessonsLearned.rejected, (state, action) => {
        state.loadingAddLessonsLearned = false;
        state.errorAddLessonsLearned = action.payload;
      })

      //---------------------------- update ------------------------------------------
      .addCase(UpdatePR_LessonsLearned.pending, (state, action) => {
        state.loadingUpdateLisLessonsLearned = true;
        state.UpdateLisLessonsLearned = action.payload;
        state.errorUpdateLisLessonsLearned = null;
      })
      .addCase(UpdatePR_LessonsLearned.fulfilled, (state, action) => {
        state.loadingUpdateLisLessonsLearned = false;
        state.UpdateLisLessonsLearned = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdatePR_LessonsLearned.rejected, (state, action) => {
        state.loadingUpdateLisLessonsLearned = false;
        state.errorUpdateLisLessonsLearned = action.payload;
      })

      //---------------------------- delete ------------------------------------------
      .addCase(DeletePR_LessonsLearnedById.pending, (state, action) => {
        state.loadingDeleteLessonsLearned = true;
        state.DeleteLessonsLearned = action.payload;
        state.errorDeleteLessonsLearned = null;
      })
      .addCase(DeletePR_LessonsLearnedById.fulfilled, (state, action) => {
        state.loadingDeleteLessonsLearned = false;
        state.DeleteLessonsLearned = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeletePR_LessonsLearnedById.rejected, (state, action) => {
        state.loadingDeleteLessonsLearned = false;
        state.errorDeleteLessonsLearned = action.payload;
      })
      //---------------------------- Get Specific Row Note LessonsLearned ------------------------------------------
      .addCase(GetSpecificRowNoteLessonsLearned.pending, (state, action) => {
        state.loadingOneSpecificRowNoteLessonsLearned = true;
        state.OneSpecificRowNoteLessonsLearned = action.payload;
        state.errorOneSpecificRowNoteLessonsLearned = null;
      })
      .addCase(GetSpecificRowNoteLessonsLearned.fulfilled, (state, action) => {
        state.loadingOneSpecificRowNoteLessonsLearned = false;
        state.OneSpecificRowNoteLessonsLearned = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSpecificRowNoteLessonsLearned.rejected, (state, action) => {
        state.loadingOneSpecificRowNoteLessonsLearned = false;
        state.errorOneSpecificRowNoteLessonsLearned = action.payload;
      });
  },
});

export default LessonsLearned.reducer;
